import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2d0519cae1b62d60402303553ecc47fd.jpg"
          alt="Start your journey"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div
          className={`max-w-2xl transition-all duration-800 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
        >
          <p className="text-amber-400 font-semibold text-sm uppercase tracking-widest mb-4">
            {t('cta.badge')}
          </p>
          <h2 className="text-5xl font-bold text-white font-playfair mb-5 leading-tight">
            {t('cta.title')}<br />{t('cta.titleLine2')}
          </h2>
          <p className="text-white/80 text-lg mb-8 leading-relaxed">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/tours"
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 text-base whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-compass-3-line mr-2"></i>{t('cta.browse')}
            </Link>
            <Link
              to="/contact"
              className="bg-white/15 hover:bg-white/25 border border-white/40 text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 text-base whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-customer-service-2-line mr-2"></i>{t('cta.consultation')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
